import React from "react";
import "./BenefitsSection.css";
import step1Icon from "../assets/icons/step1.svg";
import step2Icon from "../assets/icons/step2.svg";
import step3Icon from "../assets/icons/step3.svg";
import leafDecor from "../assets/icons/leaf_decor.svg";
import sectionLabel from "../assets/icons/section_label.svg";
import btnArrow from "../assets/icons/btn_arrow.svg";

const steps = [
  {
    icon: step1Icon,
    title: "Complete Your Intake",
    desc: "Tell us about your symptoms, health history, medications, and wellness goals. Upload a photo of your tongue for a more detailed traditional assessment.",
  },
  {
    icon: step2Icon,
    title: "Clinical Review",
    desc: "Your intake is carefully reviewed using traditional Chinese medicine diagnostic principles by a licensed herbal practitioner.",
  },
  {
    icon: step3Icon,
    title: "Custom Formula Delivered",
    desc: "Your personalized herbal blend is prepared and shipped directly to your door with clear instructions for use.",
  },
];

function BenefitsSection({ onStartQuestionnaire }) {
  return (
    <section className="benefits-section" id="how-it-works">
      <img src={leafDecor} alt="" className="benefits-leaf-decor" />
      <div className="benefits-container">
        <div className="benefits-header">
          <div className="benefits-section-label">
            <img src={sectionLabel} alt="" width="192" height="32" />
          </div>
          <h2 className="benefits-title">
            A simple, personalized approach to Chinese herbal medicine
          </h2>
        </div>

        <div className="benefits-steps">
          {steps.map((step, i) => (
            <div className="benefits-step" key={i}>
              <div className="benefits-step-top">
                <div className="benefits-step-icon">
                  <img src={step.icon} alt="" width="64" height="64" />
                </div>
                <h3 className="benefits-step-title">{step.title}</h3>
              </div>
              <div className="benefits-step-number">{i + 1}</div>
              <p className="benefits-step-desc">{step.desc}</p>
            </div>
          ))}
        </div>

        {onStartQuestionnaire && (
          <div className="benefits-cta">
            <button className="benefits-btn" onClick={onStartQuestionnaire}>
              Start your intake
              <img src={btnArrow} alt="" width="20" height="20" />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default BenefitsSection;
